module.exports = __webpack_public_path__ + "static/img/ml-huillier-flag-icon.8395aa2c.png";